<template>
  <div class="create-service">
    <Header />
    <Main>
      <b-overlay :show="loading">
        <service-form v-model="serviceData" class="create-service__form" />
      </b-overlay>
    </Main>
    <bottom-overlay v-if="edited">
      <b-button
        @click="createService"
        block
        squared
        variant="success"
        class="create-service__create-button"
        :disabled="loading"
      >
        Создать службу
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import Main from "@/components/Layout/Main";
import BottomOverlay from "@/components/BottomOverlay";
import { mapActions } from "vuex";
import ServiceForm from "@/components/Forms/Service/ServiceForm";
import ServiceModel from "@/components/Forms/Service/models/serviceModel";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: { ServiceForm, BottomOverlay, Main, Header },
  mixins: [pageTitleMixin],
  data() {
    let serviceData = new ServiceModel();
    return {
      serviceData,
      loading: false
    };
  },
  methods: {
    ...mapActions("services", {
      storeCreateService: "createService"
    }),
    async createService() {
      this.loading = true;
      try {
        await this.storeCreateService(this.serviceData);
        this.$router.push(`/employees/services`);
      } catch {
        this.loading = false;
      }
    }
  },
  computed: {
    edited: ({ serviceData }) =>
      JSON.stringify(serviceData) !== JSON.stringify(new ServiceModel())
  }
};
</script>

<style lang="scss">
.create-service {
  &__form {
    margin: 0 5px;
  }
}
</style>
